export const formatRegisteredCards = (cardList) => {
  return cardList.map(card => {
    return {
      id: card.id,
      name: `**** **** **** ${card.last_4_digits}`,
    };
  });
};

export const removeSpaceCreditCardNumber = (cardNumber) => 
  cardNumber
    .split(' ')
    .join('');